import { Vector3 } from "three";
import React, { useEffect, useState } from "react";
import Taats from "../../doors/taats";
import Paneel from "../../doors/paneel";
import { ConfigurationProps } from "../../Door";
import { useConfigurationOptionsContext } from "../../../../../app/providers/DoorOptionsProvider";

interface DoubleTaatsSinglePanelProps extends ConfigurationProps {}
const DoubleTaatsSinglePanel: React.FC<DoubleTaatsSinglePanelProps> = ({
  materials,
  position,
  rotation,
  scale,
  doorSettings,
}: DoubleTaatsSinglePanelProps) => {
  const position0 = new Vector3(-0.459, 0, 0);
  const position1 = new Vector3(0.459, 0, 0);
  const position2 = new Vector3(1.377, 0, 0);

  const { eigenwijs, getConfigurationPositions } =
    useConfigurationOptionsContext();

  const [positions, setPositions] = useState<Vector3[]>([]);

  useEffect(() => {
    setPositions(getConfigurationPositions([position0, position1, position2]));
  }, [eigenwijs?.sizeObjects]);

  return (
    <group position={position} scale={scale}>
      <Taats
        materials={materials}
        position={positions[0]}
        rotation={rotation}
        index={0}
        frameSettings={doorSettings?.main?.frameSettings}
      />
      <Taats
        materials={materials}
        position={positions[1]}
        index={1}
        frameSettings={doorSettings?.secondary?.frameSettings}
      />
      <Paneel
        materials={materials}
        position={positions[2]}
        index={2}
        frameSettings={doorSettings?.tertiary?.frameSettings}
      />
    </group>
  );
};

export default DoubleTaatsSinglePanel;
